<template>
    <div>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="学生姓名:" prop="userName">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.userName" placeholder="请输入学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="年份:" prop="year">
                    <el-date-picker
                        style="width: 200px"
                        size="mini"
                        v-model="searchForm.year"
                        type="year"
                        placeholder="选择年份"
                        format="yyyy"
                        value-format="yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysTicketItem-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysTicketItem-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                    <el-dropdown>
                         <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                             批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                         </el-button>
                         <el-dropdown-menu slot="dropdown">
                             <el-dropdown-item v-display:sysTicketItem-batchDelete icon="el-icon-delete" @click.native="batchDelete">批量删除</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-batchUpdate icon="el-icon-edit" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-batchReplace icon="el-icon-edit" @click.native="showBatchReplaceDialog">批量替换</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-leadingCurrent icon="el-icon-upload" @click.native="leadingInSysTicketItemCurrent">自定义导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-leadingIn icon="el-icon-upload" @click.native="leadingInSysTicketItem">导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-export icon="el-icon-download" @click.native="exportSysTicketItem">导出</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-exportField icon="el-icon-download" @click.native="exportSysTicketItemDialog">导出选择字段</el-dropdown-item>
                             <el-dropdown-item v-display:sysTicketItem-exportModule icon="el-icon-download" @click.native="exportSysTicketItemModule('upsertForm')">下载模板</el-dropdown-item>
                         </el-dropdown-menu>
                     </el-dropdown>
                </el-form-item>
            </el-form>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column show-overflow-tooltip prop="userName" label="学生姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="year" label="年份"></el-table-column>
            <el-table-column show-overflow-tooltip prop="type" label="类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.type && scope.row.type=='0'">图片</span>
                    <span v-if="scope.row.type && scope.row.type=='1'">PDF</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:sysTicketItem-update @click.native="showUpdateDialog(scope.row.id)">修改</el-dropdown-item>
                            <el-dropdown-item v-display:sysTicketItem-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                            <el-dropdown-item v-display:sysTicketItem-delete @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
              <el-form-item label="学生姓名" prop="userName">
                   <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.userName" placeholder="请输入学生姓名" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="年份" prop="year">
                   <el-input size="mini" maxlength="4" show-word-limit  v-model="upsertForm.year" placeholder="请输入年份" auto-complete="off"></el-input>
             </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysTicketItem-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysTicketItem-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
            <div>
                <el-form class="upsertForm" :inline="true" label-width="100px">
                    <el-form-item label="学生姓名" prop="userName">
                        <el-input size="mini" v-model="upsertForm.userName" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="年份" prop="year">
                        <el-input size="mini" v-model="upsertForm.year" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="900px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                <el-form-item label="学生姓名" prop="userName">
                   <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.userName" placeholder="请输入学生姓名" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="年份" prop="year">
                   <el-input size="mini" maxlength="4" show-word-limit  v-model="upsertForm.year" placeholder="请输入年份" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--导入结果-->
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                        <el-table-column show-overflow-tooltip prop="userName" label="学生姓名"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="year" label="年份"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
                </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                   style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                   :action="uploadUrl"
                   :headers="headers"
                   multiple
                   :show-file-list="false"
                   :on-success="handleSysTicketItemSuccess"
                   :before-upload="beforeSysTicketItemUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportSysTicketItemModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
           <div style="height: 400px;overflow-y: auto;width: 100%" >
               <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                   <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                   <el-table-column prop="key" label="英文字段名" ></el-table-column>
                   <el-table-column prop="name" label="中文字段名" ></el-table-column>
                   <el-table-column prop="newName" label="重命名字段" >
                       <template slot-scope="scope">
                           <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                       </template>
                   </el-table-column>
               </el-table>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysTicketItemByField">确认导出</el-button>
            </div>
        </el-dialog>
        <!--自定义导入-->
        <el-dialog :close-on-click-modal="false" :title="dialogCurrentExcel.title" width="980px" :visible.sync="dialogCurrentExcel.dialogFormVisible">
            <el-form class="upsertForm" ref="impForm" :inline="true"  :model="impForm" :rules="impRules">
                <div v-if="impForm.processVal==0">
                    <el-descriptions class="margin-top" :column="3" direction="vertical" size="mini" border>
                        <el-descriptions-item span="3">
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>导入文件
                            </template>
                            <el-form-item label="" prop="impPath">
                                <el-upload class="lead-in-th"
                                           style="text-align: center;line-height: 50px;border-radius: 5px;width: 100%;cursor: pointer;"
                                           :action="uploadCurrentUrl"
                                           :headers="headers"
                                           multiple
                                           :show-file-list="false"
                                           :on-success="handleSysDataImpListSelfSuccess"
                                           :before-upload="beforeSysDataImpListSelfUpload">
                                    <el-button size="small" v-if="!impForm.impPath" type="primary">点击上传</el-button>
                                    <div v-else style="width: 100%">{{impForm.impPath}}</div>
                                </el-upload>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>字段名行
                            </template>
                            <el-form-item label="" prop="fieldLine">
                                <el-input-number size="mini" v-model="impForm.fieldLine" style="width: 200px" :min="1" label="请输入字段名行"></el-input-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <span style="color: #F56C6C;margin-right: 4px;">*</span>第一个数据行
                            </template>
                            <el-form-item label="" prop="firstDataLine">
                                <el-input-number size="mini" v-model="impForm.firstDataLine" style="width: 200px"  :min="1" label="请输入第一个数据行"></el-input-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                最后数据行
                            </template>
                            <el-form-item label="" prop="lastDataLine">
                                <el-input-number size="mini" v-model="impForm.lastDataLine" style="width: 200px"  :min="1" label="请输入最后一个数据行"></el-input-number>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div v-if="impForm.processVal==1">
                    <div style="width: 100%;height: 105px;margin-top: -20px">
                        <div style="width: 40%;float: left">
                            <el-form-item label="源表">
                                <el-select size="mini" :value="currentSheet" value-key="sheetIndex" @change="updateImpForm" placeholder="请选择">
                                    <el-option
                                            v-for="item in impForm.sheetList"
                                            :key="item.sheetIndex"
                                            :label="item.sheetName+'('+item.dataRows+')条'"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div style="width: 60%;float: right;">
                            <el-form-item label="导入类型" prop="insertType">
                                <el-radio-group v-model="impForm.insertType">
                                    <p style="line-height: 30px;"><el-radio :label="0">替换：主外键唯一索引重复覆盖原有记录添加到目标表</el-radio></p>
                                    <p style="line-height: 30px;"><el-radio :label="1">忽略：忽略主外键唯一索引添加到目标表</el-radio></p>
                                    <p style="line-height: 30px;"><el-radio :label="2">复制：删除目标全部记录，并从源重新导入</el-radio></p>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div style="width: 100%;" v-if="currentSheet && currentSheet.sheetName">
                        <el-table border size="mini" height="40vh" :data="impForm.sheetList[currentSheet.sheetIndex]&&impForm.sheetList[currentSheet.sheetIndex].dataImportFieldList" style="width: 100%">
                            <el-table-column prop="sheetField" label="源字段" width="230">
                                <template slot-scope="scope">
                                    <el-input v-model="impForm.sheetList[currentSheet.sheetIndex].dataImportFieldList[scope.$index].sheetField" size="mini" placeholder="请输入源字段" style="width: 200px"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tableField" label="目标字段" width="230">
                                <template slot-scope="scope">
                                    <el-select size="mini" style="width: 100px" v-model="impForm.sheetList[currentSheet.sheetIndex].dataImportFieldList[scope.$index].tableField"  placeholder="请选择目标字段">
                                        <el-option
                                                v-for="item in impCatalogDataFieldList"
                                                :key="item.id"
                                                :label="item.name+'('+item.key+')'"
                                                :value="item.name"
                                                @click.native="setFieldInfo(impForm.sheetList[currentSheet.sheetIndex].dataImportFieldList[scope.$index],scope.$index,item)">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="dataType" label="数据类型"></el-table-column>
                            <el-table-column prop="maxLength" label="数据长度"></el-table-column>
                            <el-table-column prop="tableFieldName" label="英文字段名称"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-form>
            <div style="width: 100%;clear: both">
                <div style="width: 100%;text-align: right;margin: auto;line-height: 50px">
                    <el-button size="mini" type="primary" plain style="margin-top: 12px;" @click="impSelfNextUp">上一步</el-button>
                    <el-button size="mini" type="success" plain style="margin-top: 12px;" v-show="impForm.processVal != 1" :disabled="impForm.processVal == 1" @click.native="impSelfNextDown">下一步</el-button>
                    <el-button size="mini" type="success" plain style="margin-top: 12px;" v-show="impForm.processVal == 1" :disabled="impForm.processVal == 1">下一步</el-button>
                    <el-button size="mini" type="success" plain style="margin-top: 12px;" v-if="impForm.processVal == 1"  @click.native="startImpDataByExcel('impForm')">开始</el-button>
                    <el-button size="mini" style="margin-top: 12px;" @click="dialogCurrentExcel.dialogFormVisible=false">取消</el-button>
                </div>
            </div>
        </el-dialog>
         <!--批量替换-->
        <el-dialog :close-on-click-modal="false" :title="batchReplaceDialog.title"   width="800px" :visible.sync="batchReplaceDialog.dialogFormVisible">
            <el-form class="upsertForm" :rules="searchRules" :model="searchForm" ref="searchForm" label-width="100px" :inline="true">
                <el-form-item label="替换字段" prop="replaceField">
                    <el-select  clearable v-model="searchForm.replaceField" filterable allow-create default-first-option size="mini" placeholder="请选择保管期限">
                        <el-option v-for="item in tableFieldData" v-if="item.key!='id' && item.key!='admin_id'" :key="item.id" :label="item.name+'【'+item.key+'】'" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="替换值" prop="replaceValue">
                    <el-input  clearable size="mini" :maxlength="!tableFieldData?32:(tableFieldData.find(item => item.key === searchForm.replaceField)?tableFieldData.find(item => item.key === searchForm.replaceField).maxLength:32)" show-word-limit  v-model="searchForm.replaceValue" placeholder="请输入替换值" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="替换内容" prop="replaceContent">
                    <el-input  clearable size="mini" :maxlength="!tableFieldData?32:(tableFieldData.find(item => item.key === searchForm.replaceField)?tableFieldData.find(item => item.key === searchForm.replaceField).maxLength:32)" show-word-limit  v-model="searchForm.replaceContent" placeholder="请输入替换内容" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchReplaceDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchReplace('searchForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysTicketItem",
        components: { noData },
        data() {
            return {
                searchForm:{
                   id:'',
                   userId:'',
                   userName:'',
                   year:'',
                   createTime:'',
                   pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'userName',
                   }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    userId:'',
                    userName:'',
                    year:'',
                    createTime:''
                },
                searchRules: {
                    userId: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    userName: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    year: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    replaceField: [
                        { required: true, message: '请选择替换字段', trigger: 'blur' },
                    ],
                    replaceValue: [
                        { required: true, message: '请输入替换值', trigger: 'blur' },
                    ],
                    replaceContent: [
                        { required: true, message: '请输入替换内容', trigger: 'blur' },
                    ],
                },
                rules: {
                    userId: [
                        { required: true, message: '请输入用户编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    userName: [
                        { required: true, message: '请输入学生姓名', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    year: [
                        { required: true, message: '请输入年份', trigger: 'blur' },
                        {  max: 4, message: '长度必须少于4个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysTicketItem/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
                uploadCurrentUrl: `${home}/sysTicketItem/importByCurrentExcel`,
                dialogCurrentExcel:{
                    dialogFormVisible:false,
                    title:'自定义导入'
                },
                impRules:{
                    impPath: [
                        { required: true, message: '请上传需要导入的文件', trigger: 'blur' },
                    ],
                    fieldLine: [
                        { required: true, message: '请输入字段名行', trigger: 'blur' },
                    ],
                    firstDataLine: [
                        { required: true, message: '请输入第一个数据行', trigger: 'blur' },
                    ],
                    insertType: [
                        { required: true, message: '请选择导入类型', trigger: 'blur' },
                    ],
                },
                impForm:{
                    impType:0,
                    impPath:'',
                    fieldLine:'',
                    firstDataLine:'',
                    lastDataLine:'',
                    processVal:'',
                    sheetList: [],
                    sheetIndexList:[],
                    insertType:'',
                    catalogId:'',
                },
                currentSheet:{
                    sheetIndex:'',
                    sheetName:'',
                    tableName:'',
                    createTableStatus:'',
                    dataImportFieldList:[],
                    excelExportList:[],
                },
                newSheetList:[],
                batchReplaceDialog:{
                   dialogFormVisible:false,
                   title:'批量替换'
               },
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysTicketItem/update/findSysTicketItemById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysTicketItem/${this.dialog.title==='增加'?'saveSysTicketItem':'update/updateSysTicketItem'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysTicketItem/deleteSysTicketItem/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysTicketItem/findSysTicketItemsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysTicketItem/look/lookSysTicketItemById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInSysTicketItem() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysTicketItem() {
                axios({
                    url: `${home}/sysTicketItem/exportSysTicketItem`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "准考证打印记录列表导出.xls");
                });
            },
            exportSysTicketItemModule() {
                axios({
                    url: `${home}/sysTicketItem/exportSysTicketItemModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "准考证打印记录导入模板.xls");
                });

            },
            handleSysTicketItemSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysTicketItemUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const fileName = file.name.toLowerCase();
                if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx"))) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                    return false;
                }
                return true;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysTicketItem/batchDeleteSysTicketItem`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysTicketItemDialog(){
                axios({
                    url: `${home}/sysTicketItem/getSysTicketItemTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportSysTicketItemByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysTicketItem/exportSysTicketItemByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "准考证打印记录选择字段导出.xls");
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysTicketItem/batchUpdateSysTicketItem`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            leadingInSysTicketItemCurrent(){
                objUtil.setToDefault(this.impForm);
                this.impForm.sheetList=[];
                this.impForm.sheetIndexList=[];
                this.impForm.fieldLine = undefined;
                this.impForm.firstDataLine = undefined;
                this.impForm.lastDataLine = undefined;
                this.currentSheet = {};
                this.impForm.processVal = 0;
                this.dialogCurrentExcel.dialogFormVisible = true;
                this.dialogCurrentExcel.title = '自定义导入';
            },
            handleSysDataImpListSelfSuccess(res, file) {
                this.loading.close();
                this.impForm.impPath = res;
            },
            beforeSysDataImpListSelfUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                                            const fileName = file.name.toLowerCase();
                if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx"))) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                    return false;
                }
                return true;


            },
            impSelfNextDown(){
                if (this.impForm.processVal++ > 1) this.impForm.processVal = 0;
                if(this.impForm.processVal==1){
                  this.findSheetInfoList('impForm');
                }
            },
            impSelfNextUp(){
                if (this.impForm.processVal-- < 0) this.impForm.processVal = 0;
            },
            findSheetInfoList(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.impForm.archivesCatalogId = this.catalogId;
                        axios({
                            url: `${home}/sysTicketItem/findSheetInfoByPath`,
                            method: 'POST',
                            data: this.impForm
                        }).then(res => {
                            this.impForm.sheetList = res.data;
                            this.impCatalogDataFieldList = res.data2;
                        }).catch(error => {

                        })
                    }else{
                        this.impForm.processVal = 0;
                    }
                });
            },
            updateImpForm(e){
                this.newSheetList  = [];
                this.newSheetList.push(e);
                this.currentSheet = e;
            },
            setFieldInfo(v,index,s){
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].dataType = s.dataType;
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].maxLength = s.maxLength;
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].tableFieldName = s.key;
            },
            startImpDataByExcel(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.impForm.sheetList = JSON.parse(JSON.stringify(this.newSheetList));
                        axios({
                            url: `${home}/sysTicketItem/startImpDataByExcel`,
                            method: 'POST',
                            data: this.impForm
                        }).then(res => {
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            this.dialogCurrentExcel.dialogFormVisible = false;
                            this.submit();
                        }).catch(error => {

                        })
                    }
                });
            },
            showBatchReplaceDialog(){
                this.searchForm.replaceField='';
                this.searchForm.replaceValue='';
                this.searchForm.replaceContent='';
                axios({
                    url: `${home}/sysTicketItem/getSysTicketItemTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.batchReplaceDialog.dialogFormVisible=true;
                    this.batchReplaceDialog.title='批量替换';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.searchForm.clearValidate();
                    });
                });

            },
            batchReplace(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.$confirm("确认批量替换吗?", "温馨提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(() => {
                            this.searchForm.rowData = this.rowData;
                            axios({
                                url: `${home}/sysTicketItem/batchReplaceSysTicketItem`,
                                method: "post",
                                data: this.searchForm
                            }).then(res => {
                                this.$message({
                                    type: "success",
                                    message: "批量替换成功!"
                                });
                                this.submit();
                                this.searchForm.replaceField = '';
                                this.searchForm.replaceValue = '';
                                this.searchForm.replaceContent = '';
                                this.searchForm.rowData = [];
                                this.batchReplaceDialog.dialogFormVisible = false;
                            }).catch(error => {
                            });
                        }).catch(() => {
                            this.$message({
                                type: "error",
                                message: "批量替换失败!"
                            });
                        });
                    }
                });
            },
        }
    }
</script>
